/**
 * Web page names
 * @description: Web page names are used to identify the page of web.
 * @note: can be used to the event `enterApp`
 */
export const WEB_PAGE_NAMES = {
  HOME_PAGE: 'home-page',
  CATEGORY_LANDING_PAGE: 'category-landing-page',
  CATEGORY_PAGE: 'category-page',
  SALE_PAGE: 'sale-page',
  SEO_PAGE: 'seo-page',
  COLLECTION_PAGE: 'collection-page',
  PRODUCT_DETAIL_PAGE: 'product-detail-page',
  ACCOUNT_PAGE: 'account-page',
  BLOG_LIST_PAGE: 'blogList-page',
  BLOG_PAGE: 'blog-page',
  O2O_PAGE: 'o2o-page',
  ISS_PAGE: 'iss-page',
  SEARCH_PAGE: 'search-page',
  WISHLIST_PAGE: 'wishlist-page',
  CAMPAIGN_PAGE: 'campaign-page',
  CART_PAGE: 'cart-page',
  CHECKOUT_PAGE: 'checkout-page',
  REVIEWS_PAGE: 'reviews-page',
  CORPORATE_PAGE: 'corporate-page',
  SHOP_THE_LOOK_PAGE: 'shop-the-look-page',
  ROOM_DESIGNER_PAGE: 'room-designer-page',
  HELP_CENTER_PAGE: 'help-center-page',
  STORYBLOK_PAGE: 'storyblok-page',
};

export const WEB_PAGE_TYPES = {
  HOME_PAGE: 'home',
  CATEGORY_LANDING_PAGE: 'category-list',
  CATEGORY_PAGE: 'product',
  SALE_PAGE: 'product',
  SEO_PAGE: 'product',
  COLLECTION_PAGE: 'product',
  PRODUCT_DETAIL_PAGE: 'product',
  ACCOUNT_PAGE: 'account',
  BLOG_LIST_PAGE: 'blog',
  BLOG_PAGE: 'blog',
  O2O_PAGE: 'o2o',
  ISS_PAGE: 'iss',
  SEARCH_PAGE: 'search',
  WISHLIST_PAGE: 'account',
  CAMPAIGN_PAGE: 'campaign',
  CART_PAGE: 'cart',
  CHECKOUT_PAGE: 'checkout',
  REVIEWS_PAGE: 'reviews',
  CORPORATE_PAGE: 'corporate',
  SHOP_THE_LOOK_PAGE: 'shop-the-look',
  ROOM_DESIGNER_PAGE: 'room-designer',
  STORYBLOK_PAGE: 'campaign',
};

export const WEB_PAGE_BASIC_PARAMS = {
  [WEB_PAGE_NAMES.HOME_PAGE]: {
    pageCat: 'home',
    pageType: WEB_PAGE_TYPES.HOME_PAGE,
    pageContent: 'home',
    pageProduct: 'home',
  },
  [WEB_PAGE_NAMES.CATEGORY_LANDING_PAGE]: {
    pageCat: 'category-list',
    pageType: WEB_PAGE_TYPES.CATEGORY_LANDING_PAGE,
    pageContent: 'category-list',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.CATEGORY_PAGE]: {
    pageCat: 'product-list',
    pageType: WEB_PAGE_TYPES.CATEGORY_PAGE,
    pageContent: '',
    pageProduct: '',
  },
  [WEB_PAGE_NAMES.SALE_PAGE]: {
    pageCat: 'product-list',
    pageType: WEB_PAGE_TYPES.SALE_PAGE,
    pageContent: 'promotion',
    pageProduct: '',
  },
  [WEB_PAGE_NAMES.SEO_PAGE]: {
    pageCat: 'product-list',
    pageType: WEB_PAGE_TYPES.SEO_PAGE,
    pageContent: 'seo',
    pageProduct: '',
  },
  [WEB_PAGE_NAMES.COLLECTION_PAGE]: {
    pageCat: 'product-list',
    pageType: WEB_PAGE_TYPES.COLLECTION_PAGE,
    pageContent: 'collection',
    pageProduct: '',
  },
  [WEB_PAGE_NAMES.PRODUCT_DETAIL_PAGE]: {
    pageCat: 'product-detail',
    pageType: WEB_PAGE_TYPES.PRODUCT_DETAIL_PAGE,
    pageContent: '',
    pageProduct: '',
  },
  [WEB_PAGE_NAMES.ACCOUNT_PAGE]: {
    pageCat: 'account',
    pageType: WEB_PAGE_TYPES.ACCOUNT_PAGE,
    pageContent: 'account',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.BLOG_LIST_PAGE]: {
    pageCat: 'blog',
    pageType: WEB_PAGE_TYPES.BLOG_LIST_PAGE,
    pageContent: 'blog',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.BLOG_PAGE]: {
    pageCat: 'blog',
    pageType: WEB_PAGE_TYPES.BLOG_PAGE,
    pageContent: 'blog',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.O2O_PAGE]: {
    pageCat: 'o2o',
    pageType: WEB_PAGE_TYPES.O2O_PAGE,
    pageContent: 'o2o',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.ISS_PAGE]: {
    pageCat: 'iss',
    pageType: WEB_PAGE_TYPES.ISS_PAGE,
    pageContent: 'iss',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.SEARCH_PAGE]: {
    pageCat: 'search',
    pageType: WEB_PAGE_TYPES.SEARCH_PAGE,
    pageContent: 'search',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.WISHLIST_PAGE]: {
    pageCat: 'account',
    pageType: WEB_PAGE_TYPES.WISHLIST_PAGE,
    pageContent: 'account',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.CAMPAIGN_PAGE]: {
    pageCat: 'campaign',
    pageType: WEB_PAGE_TYPES.CAMPAIGN_PAGE,
    pageContent: 'promotion',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.CART_PAGE]: {
    pageCat: 'cart',
    pageType: WEB_PAGE_TYPES.CART_PAGE,
    pageContent: 'cart',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.CHECKOUT_PAGE]: {
    pageCat: '',
    pageType: '',
    pageContent: '',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.REVIEWS_PAGE]: {
    pageCat: 'reviews',
    pageType: WEB_PAGE_TYPES.REVIEWS_PAGE,
    pageContent: 'reviews',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.CORPORATE_PAGE]: {
    pageCat: 'corporate',
    pageType: WEB_PAGE_TYPES.CORPORATE_PAGE,
    pageContent: 'corporate',
    pageProduct: 'other',
  },
  [WEB_PAGE_NAMES.SHOP_THE_LOOK_PAGE]: {
    pageType: WEB_PAGE_TYPES.SHOP_THE_LOOK_PAGE,
    pageCat: 'Not Found',
    pageContent: 'Not Found',
    pageProduct: 'Not Found',
  },
  [WEB_PAGE_NAMES.ROOM_DESIGNER_PAGE]: {
    pageType: WEB_PAGE_TYPES.ROOM_DESIGNER_PAGE,
    pageCat: 'Not Found',
    pageContent: 'Not Found',
    pageProduct: 'Not Found',
  },
  [WEB_PAGE_NAMES.STORYBLOK_PAGE]: {
    pageType: WEB_PAGE_TYPES.STORYBLOK_PAGE,
    pageCat: 'campaign',
    pageContent: '',
    pageProduct: 'other',
  },
};
